// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum StateType {
  Map = 1,
  Lobby = 2,
  Game = 3,
  Replay = 4
}
